import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Import slices
import languageReducer from './redux/slices/languageSlice';
import brandingReducer from './redux/slices/brandingSlice';

// Currently using Redux primarily for language state
// Add more slices as needed in the future
const rootReducer = combineReducers({
  language: languageReducer,
  branding: brandingReducer,
});

// Configure Redux Persist
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['language', 'branding'], // Only persist these reducers
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable check for persisted state
    }),
});

export const persistor = persistStore(store); 